import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "./config";

// Send OTP to email
export const sendOTP = createAsyncThunk(
  "otp/sendOTP",
  async (email, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${baseUrl}send-otp`, { email });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to send OTP" }
      );
    }
  }
);

// Verify OTP
export const verifyOTP = createAsyncThunk(
  "otp/verifyOTP",
  async ({ email, otp }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${baseUrl}verify-otp`, { email, otp });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to verify OTP" }
      );
    }
  }
);

// Resend OTP
export const resendOTP = createAsyncThunk(
  "otp/resendOTP",
  async (email, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${baseUrl}resend-otp`, { email });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to resend OTP" }
      );
    }
  }
);
